/** @file Emits export attachments: region transforms, mesh uvs/tris, mounts via itemMountTransform. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, DocIndex, Pose2DJson } from '@pose2d/format/types';
import { checkSkinnedMesh } from './checkSkinnedMesh';
import { meshRecord } from './meshRecord';
import { mountMatrix } from './mountMatrix';
import { regionRecord } from './regionRecord';
import { requireAttachmentImage } from './requireAttachmentImage';

/**
 * Returns attachment records in name order (R12-01) and the id -> index map. Skinned meshes are validated here (document paths) and leave
 * without `skin`; runCompile fills it through the `skinning` stage (W2-18).
 */
export function compileAttachments(doc: Doc, index: DocIndex, boneIndex: Map<string, number>): { attachments: Pose2DJson['attachments']; attachmentIndex: Map<string, number> } {
  const attachments: Pose2DJson['attachments'] = [];
  const attachmentIndex = new Map<string, number>();
  for (const [id, att] of entriesByName(doc.attachments)) {
    const image = requireAttachmentImage(doc, id, att);
    const mount = mountMatrix(doc, id, att, image);
    attachmentIndex.set(id, attachments.length);
    if (att.type === 'region') {
      attachments.push(regionRecord(att, image, mount));
    } else {
      checkSkinnedMesh(att, id, boneIndex);
      attachments.push(meshRecord(att, image, mount));
    }
  }
  return { attachments, attachmentIndex };
}
